export default __webpack_public_path__ + "static/media/watch-filled.c6b18fe3.svg";